export default __webpack_public_path__ + "static/media/SCGJ.dffeabfd.png";